import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { Routes } from "routes";

import * as S from "./App.styles";
import { theme } from "./theme";

import { useEffect, useState } from "react";
import { AuthService } from "core/service/auth.service";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInUser = AuthService.getUser();
    setUser(loggedInUser);
  }, []);

  useEffect(() => {
    AuthService.initIntercom(user);
  }, [user]);
  return (
    <S.AppContainer>
      <ThemeProvider theme={theme}>
        <Router>
          <Routes />
        </Router>
      </ThemeProvider>
    </S.AppContainer>
  );
}

export default App;
